var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.23 10.2481V24.1875H2.99812V10.2481L14.6144 3.27875L26.23 10.2481Z",
    fill: "#FFA001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.23 10.2481V24.1875H14.6144V3.27875L26.23 10.2481Z",
    fill: "#F87F02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.2482L2.998 3.2785H14.6141L11.6161 10.2482H0Z",
    fill: "#FFDA2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2282 10.2482L26.2302 3.2785H14.6141L17.6121 10.2482H29.2282Z",
    fill: "#FCBE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73212 18.3464H8.60712V20.2214H6.73212V18.3464Z",
    fill: "#FFDA2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.8646C32 25.6515 28.93 28.7215 25.1431 28.7215C21.3556 28.7215 18.2856 25.6515 18.2856 21.8646C18.2856 18.0771 21.3556 15.0071 25.1431 15.0071C28.93 15.0071 32 18.0771 32 21.8646Z",
    fill: "#83E470"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.8646C32 25.6515 28.93 28.7215 25.1431 28.7215V15.0071C28.93 15.0071 32 18.0771 32 21.8646Z",
    fill: "#01B763"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7313 20.754L25.1431 24.3421L24.5212 24.964L21.5544 21.9971L22.8806 20.6715L24.5212 22.3121L25.1431 21.6903L27.405 19.4284L28.7313 20.754Z",
    fill: "#F3FDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7313 20.754L25.1431 24.3421V21.6903L27.405 19.4284L28.7313 20.754Z",
    fill: "#D7F3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceived);
export default __webpack_public_path__ + "static/media/Received.1cc5756d7a9af1aa3b1bc1be1c4fc866.svg";
export { ForwardRef as ReactComponent };